export default __webpack_public_path__ + "static/media/pattern_white.aee0e420.png";